export enum GroupType {
  business = 'business',
  personal = 'personal',
  sector = 'sector',
}

export interface GroupByTypeSummary {
  id: string;
  name: string;
  type: GroupType;
  subtype: string;
  picture: string | null;
  slug: string | null;
}
